import React, { useState, useEffect } from "react";
import api from "../../utils/api";
import StarIcon from "@material-ui/icons/Star";
import "./Hostels.css";
import { useDispatch, useSelector } from "react-redux";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const Hostel = ({ hostel }) => {
  const [uploader, setUploader] = useState("");
  useEffect(() => {
    // console.log("hostel", hostel);
    hostel?.userId &&
      api
        .get(`/user/getUserdataById/` + hostel?.userId)
        .then((res) => {
          // console.log("user", res?.data);
          setUploader(res?.data);
        })
        .catch((err) => console.log("err", err));
  }, [hostel]);
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const [hostelRating, setHostelRating] = useState(0);
  const [hostelRatingCount, setHostelRatingCount] = useState(0);
  const [isAlreadyReviewed, setIsAlreadyReviewed] = useState(false);
  const [rating, setRating] = useState(0);
  const navigate = useNavigate();
  const submitRating = (id) => {
    // console.log("rating>", rating, id);
    if (rating !== 0) {
      const body = {
        userId: currentUser?.id,
        hostelId: hostel?._id,
        rating: rating,
      };
      api
        .post("/hostels/submit-rating", body)
        .then((res) => {
          // console.log("res>", res.data);
          let notifBody = {
            userId: currentUser?.id,
            text: `${currentUser?.name} gives your hostel upload a ${rating} star rating.`,
            forAll: false,
            receiverId: hostel?.userId,
          };
          api
            .post("/notifications", notifBody)
            .then((re) => console.log("notif", re.data));
          window.location.reload();
        })
        .catch((err) => console.log(err));
      setRating(0);
    }
  };
  useEffect(() => {
    api
      .get(`/hostels/ratings/${hostel?._id}`)
      .then((res) => {
        // console.log("hostel ratings", res.data);
        // console.log("user id>", currentUser?.id);
        if (res.data.length > 0) {
          let total = 0;
          let count = 0;
          res.data.map((r) => {
            console.log("not equal");
            if (r.userId == currentUser?.id) {
              // console.log("are equal");
              setIsAlreadyReviewed(true);
            }
            total = total + r.rating;
            count++;
          });
          setHostelRating(total / count);
          // console.log("hostel rating", total);
          setHostelRatingCount(count);
        }
      })
      .catch((err) => console.log);
  }, []);
  useEffect(() => {
    console.log("isAlreday review", isAlreadyReviewed);
  }, [isAlreadyReviewed]);
  const deleteHostel = (h) => {
    console.log("hostel", hostel);
    api
      .delete(`/hostels/${h?._id}`)
      .then((res) => {
        if (res.data) {
          let notifBody = {
            userId: currentUser?.id,
            text: `Admin delete your hostel for violating terms and conditions.`,
            forAll: false,
            receiverId: h?.userId,
          };
          api
            .post("/notifications", notifBody)
            .then((re) => console.log("notif", re.data));
          window.location.reload();
        }
      })
      .catch((err) => console.log);
  };

  return (
    <>
      <Card
        sx={{
          width: "100%",
          marginTop: "20px",
          boxShadow: "rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px",
        }}
      >
        <CardHeader
          onClick={() => navigate(`/user-profile/${hostel?.userId}`)}
          className="title__link"
          avatar={
            <Stack direction="column">
              {uploader?.profile ? (
                <Avatar src={uploader?.profile} />
              ) : (
                <Avatar sx={{ bgcolor: "colorThree.main" }} aria-label="recipe">
                  {uploader?.name?.at(0)?.toUpperCase()}
                </Avatar>
              )}
            </Stack>
          }
          // action={
          //   <IconButton aria-label="settings">
          //     <MoreVertIcon />
          //   </IconButton>
          // }
          title={uploader?.name?.toUpperCase()}
          subheader={new Date(hostel?.createdAt).toDateString()}
        />
        <CardContent sx={{ marginTop: "-20px" }}>
          <Grid container>
            <Grid
              item
              xs={12}
              sm={4}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {hostel?.hostelImages?.length > 0 && (
                <img
                  style={{
                    margin: "0px 0",
                    marginLeft: "50%",
                    transform: "translateX(-50%)",
                  }}
                  height="auto"
                  width="100%"
                  src={hostel?.hostelImages[0]}
                  alt="Paella dish"
                />
              )}
            </Grid>
            <Grid item xs={12} sm={8} sx={{ padding: "0px 20px 20px 20px" }}>
              <Typography
                variant="h5"
                sx={{ textTransform: "whitesmoke", fontWeight: "600" }}
                className="title__link"
                onClick={() => navigate(`/hostel-details/${hostel?._id}`)}
              >
                {hostel?.generalData?.hostelName}
              </Typography>

              <Typography variant="body2" sx={{ marginBottom: "5px" }}>
                {hostel?.generalData?.city}, {hostel?.generalData?.state}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                {hostelRating === 0 ? (
                  ""
                ) : (
                  <>
                    {" "}
                    {Array(parseInt(hostelRating))
                      .fill()
                      .map((_, i) => (
                        <span>
                          <StarIcon style={{ color: "gold" }} />
                        </span>
                      ))}
                    <Typography variant="body2">
                      {parseInt(hostelRating)}
                    </Typography>
                    &nbsp;
                    <Typography variant="body2">
                      ({hostelRatingCount})
                    </Typography>
                  </>
                )}
              </Box>
              <Box sx={{ display: "flex" }}>
                {hostel?.facilities?.map((f) => (
                  <Typography
                    variant="body2"
                    sx={{
                      border: "1px solid lightgray",
                      width: "max-content",
                      padding: "2px 4px",
                      margin: "3px",
                      color: "colorThree.main",
                    }}
                  >
                    {f}
                  </Typography>
                ))}
              </Box>

              <Typography
                className="ellipsis__two__lines"
                variant="body2"
                sx={{ margin: "14px 0", color: "gray" }}
              >
                {hostel?.generalData?.hostelDetails}
              </Typography>

              {/* <Box className="country mt-2 mb-1 flex">
            <Typography
              variant="body2"
              sx={{
                color: "fontSecondaryColor.main",
                width: "150px",
              }}
            >
              Location
            </Typography>
            <Typography variant="body2" sx={{ marginLeft: "12px" }}>
              {hostel?.generalData?.city}
            </Typography>
          </Box> */}

              {/* <Box
            className="tags bg-white mt-3 mb-3"
            sx={{ width: "max-content" }}
          >
            {hostel?.tags?.map((t) => (
              <Typography className="tag-span">{t}</Typography>
            ))}
          </Box> */}
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  sx={{
                    backgroundColor: "colorThree.main",
                    color: "#fff",
                    padding: "1px 3px",
                  }}
                >
                  {hostel?.generalData?.hostelCategory}
                </Typography>
                {/* <Typography
                  variant="p"
                  sx={{ cursor: "pointer" }}
                  onClick={() => navigate(`/hostel-details/${hostel?._id}`)}
                >
                  details
                </Typography> */}
              </Box>

              {currentUser?.isAdmin ? (
                // <button
                //   className=" asc__submit__form__button"
                //   onClick={() => deleteHostel(hostel)}
                // >
                //   Delete Hostel
                // </button>
                <></>
              ) : (
                <>
                  {hostel?.userId !== currentUser?.id && (
                    <>
                      {/* {isAlreadyReviewed ? (
                    <Typography variant="body2" color="gray">
                      rating given
                    </Typography>
                  ) : (
                    <Box
                      className=" row m-0 mt-3"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row",
                      }}
                    >
                      <Box className={"col-6 rating__wrapper"}>
                        <Typography
                          variant="body2"
                          sx={{ textDecoration: "underline" }}
                        >
                          Rate it{" "}
                        </Typography>
                        <Box className="rating__stars">
                          <span
                            onClick={() => setRating(1)}
                            className={
                              (rating === 1 && "shine") ||
                              (rating === 2 && "shine") ||
                              (rating === 3 && "shine") ||
                              (rating === 4 && "shine") ||
                              (rating === 5 && "shine")
                            }
                          >
                            <StarIcon />
                          </span>
                          <span
                            onClick={() => setRating(2)}
                            className={
                              (rating === 2 && "shine") ||
                              (rating === 3 && "shine") ||
                              (rating === 4 && "shine") ||
                              (rating === 5 && "shine")
                            }
                          >
                            <StarIcon />
                          </span>
                          <span
                            onClick={() => setRating(3)}
                            className={
                              (rating === 3 && "shine") ||
                              (rating === 4 && "shine") ||
                              (rating === 5 && "shine")
                            }
                          >
                            <StarIcon />
                          </span>
                          <span
                            onClick={() => setRating(4)}
                            className={
                              (rating === 4 && "shine") ||
                              (rating === 5 && "shine")
                            }
                          >
                            <StarIcon />
                          </span>
                          <span
                            onClick={() => setRating(5)}
                            className={rating === 5 && "shine"}
                          >
                            <StarIcon />
                          </span>
                        </Box>
                      </Box>
                      <Box
                        className="col-6 "
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: "-10px",
                        }}
                      >
                      
                        <button
                          className="asc__submit__form__button"
                          onClick={() => submitRating(hostel?._id)}
                          sx={{ marginTop: "-10px" }}
                        >
                          <span className="fa fa-send"></span> submit rating
                        </button>
                      </Box>
                    </Box>
                  )} */}
                    </>
                  )}
                </>
              )}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};

export default Hostel;
